
import { useContext } from "react";
import { CgAdd } from "react-icons/cg";
import { AuthContext } from "../../contexts/auth";
import { Link } from 'react-router-dom'
import { FiAlignJustify } from 'react-icons/fi';
import ClienteSelecionado from '../ClienteSelecionado/clienteSelecionado';

export default function Titulo({tela, destination, nomeBase, codigoBase, permissao}){
  const { perfilUsuario, permissoes, togleMenu } = useContext(AuthContext);
  let urlDestino = destination;

  if (nomeBase) {
    urlDestino = urlDestino + `${nomeBase}`;
  }

  if (codigoBase) {
    urlDestino = urlDestino + '/' + `${codigoBase}`;
  }

  // Situação anterior a 20250821
  //(destination !== '' && (perfilUsuario === 'GS' || perfilUsuario === 'AD')) ? (

  return(  
    <section>
      <div className="flex bg-secondary-500 text-white px-4 py-2 gap-4 items-center">
        <div>
          <button className='action' onClick={togleMenu}>
            <FiAlignJustify size={25} color="white" />
          </button>
        </div>
        <div className="text-blue px-4">
          <ClienteSelecionado />
        </div>
        <p></p>
        <div className="title-page">
          <h2 className='font-semibold text-sm text-white'>{tela}</h2>
        </div>
        { 
          (destination !== '' && permissoes.includes(permissao)) ? (
            <div className='botaonovo'>
              <Link to={urlDestino}>
                <CgAdd size={25} color="white" />
              </Link>
            </div>
          ) : (
            <p></p>
          )
        }
      </div>
    </section>
  )
}
